module.exports = __webpack_public_path__ + "05_face.c7a21ce3.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/dad/layer1/05_face.png
// module id = Urhs
// module chunks = 0